export default {
  // Dock and More views drawer
  crm: 'CRM',
  moreViews: 'More views',
  customizeDock: 'Customize dock',
  unreadItems: 'Unread items',
  views: 'Views',

  // Search category pills
  all: 'All',
  projects: 'Projects',
  people: 'People',

  // New button and create menu
  new: 'New',
  newEmail: 'New email',
  newMessage: 'New message',
  newDocument: 'New document',
  newTask: 'New task',
  newCompany: 'New company',
  company: 'Company',
  event: 'Event',
  call: 'Call',
  more: 'More',
  createNew: 'Create new',
  chooseWhatToCreate: 'Choose what to create.',
  closeCreateMenu: 'Close create menu',

  // Confirmation drawer
  closeConfirmation: 'Close confirmation',
  cancel: 'Cancel',
  confirm: 'Confirm',

  // Picker sheet
  done: 'Done',
};
